import { useLocation } from 'react-router';
import { useMemo } from 'react';

const useURLSearchParams = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

export default useURLSearchParams;
